module.exports = __webpack_public_path__ + "static/img/logo-gopay.a4b374f3.png";